$(document).ready(function(){
  var header = $('header');
  var main = $('.site-content');
  scrollPrev = 0;

  $(window).scroll(function () {
    var scrolled = $(window).scrollTop();

    if (scrolled > 150 && scrolled) {
      header.addClass('out-translate');
    } else {
      header.removeClass('out-translate');
    }

    if (scrolled > 250 && scrolled) {
      header.addClass('out');
      main.addClass('out');
    } else {
      header.removeClass('out');
      main.removeClass('out');
    }

  });

  const select = document.querySelectorAll(".select");
  if (select.length) {
    select.forEach((item) => {
      const selectCurrent = item.querySelector(".select__current");
      item.addEventListener("click", (event) => {
        const el = event.target.dataset.choice;
        const text = event.target.innerText;
        if (el === "choosen" && selectCurrent.innerText !== text) {
          selectCurrent.innerText = text;
        }
        item.classList.toggle("active");
      });
      document.addEventListener("click", function (event) {
        if (!item.contains(event.target)) {
          item.classList.remove("active");
        }
      });
    });
  }

  if ($(window).width() <= 576) {
    $('.main-tabs__link').removeAttr("data-tab")
  }


  let tabParents = document.querySelectorAll("[data-parent-tabs]");
  tabParents.forEach(function(tabParent){
    let tabNavs = tabParent.querySelectorAll("[data-tab]");
    let tabPanes = tabParent.querySelectorAll("[data-tab-content]");

    for (let i = 0; i < tabNavs.length; i++) {
  
      tabNavs[i].addEventListener("click", function(e){
        e.preventDefault();
        let activeTabAttr = e.target.getAttribute("data-tab");
    
        for (let j = 0; j < tabNavs.length; j++) {
          let contentAttr = tabPanes[j].getAttribute("data-tab-content");
    
          if (activeTabAttr === contentAttr) {
            tabNavs[j].classList.add("active");
            tabPanes[j].classList.add("active");
          } else {
            tabNavs[j].classList.remove("active");
            tabPanes[j].classList.remove("active");
          }
        };
      });
    }
});

let tabInner = document.querySelectorAll("[data-inner]");

if (tabInner) {
  tabInner.forEach(function(item){
    let tabNavs = item.querySelectorAll("[data-inner-tab]");
    let tabPanes = item.querySelectorAll("[data-inner-tab-content]");
    for (let i = 0; i < tabNavs.length; i++) {
    
      tabNavs[i].addEventListener("click", function(e){
        e.preventDefault();
        let activeTabAttr = e.target.getAttribute("data-inner-tab");
    
        for (let j = 0; j < tabNavs.length; j++) {
          let contentAttr = tabPanes[j].getAttribute("data-inner-tab-content");
    
          if (activeTabAttr === contentAttr) {
            tabNavs[j].classList.add("active");
            tabPanes[j].classList.add("active");
          } else {
            tabNavs[j].classList.remove("active");
            tabPanes[j].classList.remove("active");
          }
        };
      });
    }
  });
}



let accFirst = document.querySelectorAll(".accordion");
let i;
for (i = 0; i < accFirst.length; i++) {
  accFirst[i].addEventListener("click", function() {
    this.classList.toggle("active");
    let panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}

let openControl = document.querySelector('[data-open]');
if (openControl) {
  openControl = +openControl.dataset.open - 1
}
for (i = 0; i < accFirst.length; i++) {
  accFirst[`${openControl}`].click(); //--- открыть первый акордион по умолчанию
}

var headerHeigth = $('header').height()

if ($(window).width() >= 1024) {
  $('.header-nav__item').on('click', function (e) {
  let $that = $(this)
  $that.addClass('active');
  $(".header-nav__item").not(this).removeClass('active');
  $('body').addClass('fixed');
  });
}

if ($(window).width() <= 1024) {
  $('.mobile-burger').on('click', function (e) {
    $('.header-nav__list').css("max-height",`calc(100vh - ${$('header').height()}px `);
    $(this).toggleClass('active');
    $('.mobile-menu').toggleClass('active');
    $('body').toggleClass('fixed');
    $(".accordion-mobile").next().css('max-height', '0');
    $(".accordion-mobile").removeClass('active');
  });

}

$(document).mouseup( function(e){ 
  e.stopPropagation();
  var div = $(".mobile-menu"); 
  var button = $(".mobile-burger"); 
  if ($(window).width() <= '1024'){
    if ( !div.is(e.target) && div.has(e.target).length === 0 && !button.is(e.target) && button.has(e.target).length === 0 ) { 
        $(".accordion-mobile").next().css('max-height', '0');
        $(".accordion-mobile").removeClass('active');
        $('body').removeClass('fixed');
        $('.mobile-menu').removeClass('active');
        $('.mobile-burger').removeClass('active');
    }
  }
});

$(document).mouseup( function(e){ 
  e.stopPropagation();
  var div = $(".sub-menu"); 
  if ($(window).width() > 1024){
    if ( !div.is(e.target) 
      && div.has(e.target).length === 0) { 
        $('.header-nav__item').removeClass('active');
        $('body').removeClass('fixed');
        $('.mobile-menu').removeClass('active');
    }
  }
});

$('.blog__nav-button').on('click', function () {
  $('.blog__nav-button').removeClass('active');
  $(this).addClass('active');
});

// ------ open time line ------

$('.show-more').on('click', function(){
  let panel = this.nextElementSibling;
  var $that = $(this);
  if(!$that.hasClass('hide')) {
    $that.addClass('hide');
    $that.text('Close full timeline');
    panel.classList.add('opacity');
  } else {
    $that.removeClass('hide');
    $that.text('Open full timeline');
    panel.classList.remove('opacity');
  }

  if (panel.style.maxHeight) {
    panel.style.maxHeight = null;
  } else {
    panel.style.maxHeight = panel.scrollHeight + 'px';
  }
});

var productBottom = new Swiper('.product-slider__bottom', {
  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 0,
  loop: false,
  centeredSlides: true,
  observer: true,
  observeParents: true,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});

var migrateImage = $(".product-migartion__image")[0];
var migrationArticle = $(".product-migartion__article")[0];
var oldParent = $('.product-migartion__wrapper')[0];

function replaceMigrateImage(){
  if ($(window).width() <= 991) {
    migrationArticle && migrationArticle.insertAdjacentElement("afterbegin", migrateImage);

  } else {
    oldParent && oldParent.insertAdjacentElement("afterbegin", migrateImage);
  }
}

if (migrateImage) {
  if (document.documentElement.clientWidth < 992 && oldParent ) {
    replaceMigrateImage()
  }

  window.addEventListener('resize', () => {
    replaceMigrateImage()
  });
}

if ($(window).width() >= 575 ) {
  $('.blog-top .blog-search').on('click', function () {
    $(this).addClass('show');
  })
} else {
  $('.blog-top .blog-search').on('click', function () {
    $('.search-mob').addClass('show');
  })
}

})

let test = document.querySelector('.partners-tabs__select select');

if (test) {
test.addEventListener('change', function() {
  document.querySelectorAll('.partners-tab').forEach((n, i) => {
    n.classList.toggle('active', i === this.selectedIndex);
  });
});
}

$('.partners-tabs__select select').on('click', function () {
$(this).toggleClass('active');
})

$('.partners-tabs__select select option').on('click', function () {
$('.partners-tabs__select select').removeClass('active');
})

$('.partners-tab__item').on('click', function () {
$(this).toggleClass('active');
})


let swiperTop = new Swiper('.slider-top', {
slidesPerView: "auto",
spaceBetween: 0,
slidesPerGroup: 1,
loopPreventsSlide: false,
loop: true,
speed: 4000,
autoplay: {
  delay: 0,
  disableOnInteraction: true,
}
});


let swiperBottom = new Swiper('.slider-bottom', {
slidesPerView: "auto",
spaceBetween: 0,
slidesPerGroup: 1,
loopPreventsSlide: false,
loop: true,
speed: 4000,
autoplay: {
  delay: 0,
  reverseDirection: true,
  disableOnInteraction: true,
}
});

if (swiperTop) {
swiperTop.autoplay.start();
}
if (swiperBottom) {
swiperBottom.autoplay.start();
}


function mobileClasses(){
if ($(window).width() <= 1024) {
  $('.header-nav__item > a').each(function(){
    let targetLink = $(this);
    targetLink.addClass('accordion-mobile');
    targetLink.next().wrap('<div class="panel"/>'); 
 });

} else {
  $('.header-nav__item > a').each(function(){
    let targetLink = $(this);
    targetLink.removeClass('accordion-mobile');
    $('.panel > .sub-menu').unwrap(); 
 });
}
}

if ($(window).width() <= 1024) {
  mobileClasses()
}

window.addEventListener('resize', () => {
  mobileClasses()
});




// accordion

const getAccordions = function(className = ".accordion-mobile") {
return document.querySelectorAll(className);
}

const accordions = getAccordions();
let openedAccordion = null;

const closeAccordion = function (accordion) {
accordion.style.maxHeight = 0;
};

const openAccordion = function (accordion) {
accordion.style.maxHeight = accordion.scrollHeight + "px";
};

const toggleAccordionButton = function (button, className = "active") {
button.classList.toggle(className);
};

const checkIsAccordionOpen = function(accordion) {
return accordion.style.maxHeight && accordion.style.maxHeight !== "0px";
}

const accordionClickHandler = function () {
toggleAccordionButton(this);

const accordionContent = this.nextElementSibling;
const isAccordionOpen = checkIsAccordionOpen(accordionContent);

if (isAccordionOpen) {
  closeAccordion(accordionContent);
  openedAccordion = null;
} else {
  if (openedAccordion != null) {
    closeAccordion(openedAccordion);
    const accordionButton = openedAccordion.previousElementSibling
    toggleAccordionButton(accordionButton);
  }
  openAccordion(accordionContent);
  openedAccordion = accordionContent;
}
}

const activateAccordion = function(accordions, handler) {
for (const accordion of accordions) {
  accordion.addEventListener('click', handler)
}
}
activateAccordion(accordions,accordionClickHandler);

// acoordion

$(document).ready(function() {
$('.header-nav__item > a').each(function(){
  $(this).removeAttr('href');
});


$('.single-blog').closest('.site-content').css("overflow-x","initial");

});




//////////////////
// WEBPACK FOOTER
// ./src/js/custom/main.js
// module id = 340
// module chunks = 0